export const FETCH_STUDENT_STATUSES = "FETCH_STUDENT_STATUSES";

export const INSERT_STUDENT_STATUS = "INSERT_STUDENT_STATUS";

export const DELETE_STUDENT_STATUS = "DELETE_STUDENT_STATUS";

export const EDIT_STUDENT_STATUS_INFO = "EDIT_STUDENT_STATUS_INFO";
